// extracted by mini-css-extract-plugin
module.exports = {"faqSection":"SgFaqSectionComponent_faqSection__29_Ne","gwSectionTitle":"SgFaqSectionComponent_gwSectionTitle__3w4-T"};